import axios from './request'

/**
 * 查询是否授权接口
 */
export function redBookQueryAuth() {
  return axios.post('/qmarket/api/redBook/queryAuth')
  // return axios.post('http://market.qunar.com/api/redBook/queryAuth')
}

export const BookReportScene = {
  /** 进入页面 */
  uv: 'uv',
  /** 授权 */
  auth: 'auth',
  /** 领取礼包后回调 */
  callback: 'callback'
}

/**
 * 进入页面、授权、领取礼包接口
 */
export function redBookReportProcess({ identifyCode, scene }) {
  return axios.post(`/qmarket/api/redBook/process?identifyCode=${identifyCode}&scene=${scene}`)
}
